import { render, staticRenderFns } from "./CardPaymentConfigForm.vue?vue&type=template&id=4d86daf4"
import script from "./CardPaymentConfigForm.vue?vue&type=script&lang=js"
export * from "./CardPaymentConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports